import Axios, { Response } from "../util/Axios";

export type CardType = {
  ccard_company: string;
  ccard_exp: number;
  ccard_id: number;
  ccard_name: string;
  ccard_name_show: string;
  created_at: string;
  is_default: number;
  number: string;
  number_show: string;
  status: number;
  updated_at: string | null;
  user_id: number;
};

const CardController = {
  cardList: async (): Promise<Response> => {
    try {
      let sUrl = process.env.REACT_APP_API_URL + "/obigo/card/list";
      const response: any = await Axios.post(sUrl);
      return response;
    } catch (err) {
      let oErr: any = err;
      return {
        ok: false,
        msg: "[카드 조회 오류]" + oErr.toString(),
        data: undefined,
        status: 500,
      };
    }
  },
  cardSetMain: async (oParams: any): Promise<Response> => {
    try {
      let sUrl = process.env.REACT_APP_API_URL + "/obigo/card/setMain";
      const response: any = await Axios.post(sUrl, oParams);
      return response;
    } catch (err) {
      let oErr: any = err;
      return {
        ok: false,
        msg: "[메인 카드 설정 오류]" + oErr.toString(),
        data: undefined,
        status: 500,
      };
    }
  },
};
export default CardController;
